import React from 'react';

interface ComboExtendGlyphProps {
  /** Which side the new segment joins on. */
  direction: 'left' | 'right';
  size?: number;
  className?: string;
}

/**
 * Minimal "combo left / combo right" mark: a plus (add a segment) with a chevron pointing to the
 * side it is added on — "‹+" and "+›".
 */
const ComboExtendGlyph: React.FC<ComboExtendGlyphProps> = ({ direction, size = 19, className }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g transform={direction === 'right' ? 'translate(24 0) scale(-1 1)' : undefined}>
      <path d="m9 7-5 5 5 5" />
      <path d="M16 8v8M12 12h8" />
    </g>
  </svg>
);

export default ComboExtendGlyph;
